import apiClient from './client';
import type { User, PaginatedResponse, SingleResponse } from '@/types';

export interface UserListParams { page?: number; limit?: number; search?: string; }
export interface CreateUserPayload  { username: string; email: string; password: string; role: 'admin' | 'readonly'; }
export interface UpdateUserPayload  { username?: string; email?: string; role?: 'admin' | 'readonly'; is_active?: boolean; }
export interface ChangePasswordPayload { current_password?: string; new_password: string; }

export const usersApi = {
  list: (params: UserListParams = {}) =>
    apiClient.get<PaginatedResponse<User>>('/users', { params }).then(r => r.data),

  get: (id: string) =>
    apiClient.get<SingleResponse<User>>(`/users/${id}`).then(r => r.data.data),

  create: (data: CreateUserPayload) =>
    apiClient.post<SingleResponse<User>>('/users', data).then(r => r.data.data),

  update: (id: string, data: UpdateUserPayload) =>
    apiClient.put<SingleResponse<User>>(`/users/${id}`, data).then(r => r.data.data),

  changePassword: (id: string, data: ChangePasswordPayload) =>
    apiClient.patch(`/users/${id}/password`, data).then(r => r.data),

  delete: (id: string) =>
    apiClient.delete(`/users/${id}`).then(r => r.data),

  /** Soft-deactivate a user (calls the DELETE endpoint which does a soft delete) */
  deactivate: (id: string) =>
    apiClient.delete(`/users/${id}`).then(r => r.data),
};
